<div id="mainWrapper" class="container">
  <cart-header [customer]="customerInfo"></cart-header>
  <section id="content-wrapper">
    <main id="site-main">
      <div class="wrap overflow-visible" >
        <router-outlet></router-outlet>
      </div>
    </main>
  </section>
</div>
